import { ChangeDetectorRef, Component } from '@angular/core';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';
import { CTA_LINKS, HEADER_DATA } from '../../Data/data.service';
import { environment } from '../../../environments/environment';

interface CtaButton {
  text: string;
  url: string;
  target?: string;
  primary: boolean;
}

interface HeaderData {
  logo: {
    src: string;
    alt: string;
  };
  navigation: Array<{
    name: string;
    url: string;
  }>;
  ctaButtons: Array<{
    text: string;
    url: string;
    target: string;
    primary: boolean;
  }>;
}

type HomeSection = 'core-modules' | 'applications';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './header.html',      //  correct spelling
  styleUrls: ['./header.css'],       //  correct spelling
})
export class HeaderComponent {
  readonly ctaLinks = CTA_LINKS;
  readonly headerData: any = HEADER_DATA;
  readonly erpBaseUrl = environment.erpBaseUrl;

  showMobileMenu = false;

  // Core modules / Applications both route to "/" with a different fragment, so
  // routerLinkActive can't tell them apart — track which one was actually clicked instead.
  activeHomeSection: HomeSection | null = null;

  constructor(private router: Router, private cdr: ChangeDetectorRef) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
      const url = (event as NavigationEnd).urlAfterRedirects;
      if (url.split(/[?#]/)[0] !== '/') {
        this.activeHomeSection = null;
        this.cdr.detectChanges();
      }
    });
  }

  setActiveHomeSection(section: HomeSection): void {
    this.activeHomeSection = section;
  }

  toggleMobileMenu(): void {
    this.showMobileMenu = !this.showMobileMenu;
  }

  closeMobileMenu(): void {
    this.showMobileMenu = false;
  }

  scrollToTop(): void {
    this.closeMobileMenu();
    this.activeHomeSection = null;
    this.router.navigate(['/']).then(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  downloadApp(): void {
    window.open(this.ctaLinks.download.url, this.ctaLinks.download.target);
  }

  goToProduct(): void {
    this.router.navigate(['/product']).then(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  trackByNavItem(index: number, navItem: any): string {
    return navItem.name;
  }

  trackByButton(index: number, button: any): string {
    return button.text;
  }
}
